import { useEffect, useState } from "react";

// Retorna `value` com um atraso de `delay` ms, só atualizando quando o
// utilizador para de digitar (evita disparar buscas a cada tecla).
export function useDebouncedValue(value, delay = 4000) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
